// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"PostsPage_userInfo__2HVYZ"};